import React from 'react';
import { Link } from 'react-router-dom';
import styles from './EnterpriseCard.module.css';

const EnterpriseCard = () => {
  return (
    <div className={styles.enterprise}>
      <div className={styles.enterprise__content}>
        <h3 className={styles.enterprise__title}>Enterprise</h3>
        <p className={styles.enterprise__description}>
          For larger companies with complex needs and controls.<br />
          Advanced tools for security.
        </p>
      </div>
      <div className={styles.enterprise__action}>
        <Link to="/contact-us" className={styles.enterprise__button}>
          Contact Sales
        </Link>
      </div>
    </div>
  );
};

export default EnterpriseCard;
